interface PostLoginBySocialReturns {
  error?: string;
  data?: {
    at: string;
    rt: string;
    email: string;
    isAgreed: boolean;
  }
}
/** 소셜 로그인 */
const postLoginBySocial = (
  socialType: 'google' | 'facebook' | 'test',
) => new Promise<PostLoginBySocialReturns>((resolve) => {
  let url = `/auth/social/${socialType}?redirect=/`;
  if (socialType === 'test') url = '/auth/social/google/test?redirect=/';

  const socialWindow = window.open(url, `social-${socialType}`, 'width=600,height=500');
  const interval = setInterval(() => {
    try {
      const {
        at, rt, email, isAgreed, deletedAt,
      } = socialWindow as any;
      if (at && rt) {
        resolve({
          data: {
            at, rt, email, isAgreed,
          },
        });
        clearInterval(interval);
        socialWindow?.close();
        return;
      }
      if (Number(deletedAt)) {
        resolve({
          data: {
            at: '', rt: '', email, isAgreed,
          },
          error: `will be deleted at:${deletedAt}`,
        });
        clearInterval(interval);
        socialWindow?.close();
        return;
      }

      if (!socialWindow || socialWindow?.closed) {
        resolve({ error: 'user close' });
        clearInterval(interval);
      }
      window.focus();
    } catch (e) {
      //
    }
  }, 0);
});

export default postLoginBySocial;
